import { Injectable, inject } from '@angular/core';
import { Observable, forkJoin, map } from 'rxjs';
import { MenuService } from './menu.service';
import { RouteConfigService } from './route-config.service';

/**
 * Loads what the shell is built from: the sidebar menu and the route table, two ui_config rows read through the BFF.
 * Both calls need the user's JWT, so this runs only when there is a session: at boot when one is restored
 * (`APP_INITIALIZER`) and right after a login, because a login does not reload the page and the boot found no session.
 *
 * Each load keeps its own failure in a signal (`loadError`) instead of throwing, so this never errors: the shell shows the
 * message once it is rendered.
 */
@Injectable({ providedIn: 'root' })
export class UiConfigBootstrapService {
  private menu   = inject(MenuService);
  private routes = inject(RouteConfigService);

  load(): Observable<void> {
    return forkJoin([this.menu.load(), this.routes.load()]).pipe(map(() => void 0));
  }
}
